import React, { useContext, useState } from 'react';
import Modal from '../../../UI/Modal/Modal';
import cl from '../Form.module.css';
import { AppContext } from '../../../../providers/appProvider';
import Remove from "../../../../assets/Icon/Remove";
import { useTranslation } from 'react-i18next';

const Delete = ({ agentCRMService, defaultAgentCRM }) => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { app } = useContext(AppContext);

    const confirmDelete = () => {
        agentCRMService.remove(defaultAgentCRM.id)
            .then(() => setIsModalOpen(false))
            .catch(() => {
                setIsModalOpen(false);
                app.setError("შეცდომა წაშლისას");
            });
    };

    return (
        <div>
            <span className={cl.removeBtn} onClick={() => setIsModalOpen(true)}>
                <Remove /> {t('Delete')}
            </span>

            <Modal key={defaultAgentCRM.id} size="medium" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className={cl.modalHead}><h3>{t('Delete')}</h3></div>
                <div className={cl.message}>{t('ConfirmDelete')}</div>
                <div className={cl.buttons}>
                    <button className={cl.removeBtnYes} onClick={confirmDelete}>{t('YesIdo')}</button>
                </div>
            </Modal>
        </div>
    );
};

export default Delete;
